import React from 'react';
import courseScheduleStyle from './style';

export default function CourseSchedule({days, mt}) {
	let style = courseScheduleStyle();

	return (
		<div style={style.outerStyle({mt: mt})}>
			{/* This div works like a clostrophobic person. It stays in the middle and requies space */}
			<div style={style.contentContainerStyle()}>
				<h1 style={style.titleStyle()}>Schedule</h1>
				{days.map((day, i) => {
					return (
						<div key={Math.random()} style={style.dayRow()}>
							{i != 0 ? <hr style={style.hrStyle()} className={style.hrClasses()} /> : <></>}
							<div key={Math.random()} style={style.textContentContainerStyle()}>
								<p className={style.textClasses()} style={style.textStyle()} key={Math.random()}>
									{day.name}
								</p>
								<p className={style.textClasses()} style={style.textStyle()} key={Math.random()}>
									{day.action}
								</p>
							</div>
						</div>
					);
				})}
				<div></div>
			</div>
		</div>
	);
}
